import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import IconPdf from '../../../images/icon/pdf.png';
import IconDoc from '../../../images/icon/doc.png';
import AboutPic3 from '../../../images/about/worker_oilgaz.jpg';
import HeadPhones from '../../../images/icon/headphones.png';

class SolutionSidebar extends Component{
	render(){
		return(
			<>
				<aside className="sticky-top">
					<div className="widget">
						<ul className="service-list">
	<li className={this.props.activeService==10  ? "active":""}>
		<Link to="/SolutionEnergy">
			<span>Electrical & Power Engineering</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>
	<li className={this.props.activeService==1  ? "active":""}>
		<Link to="/SolutionGeologicalReservoirAnalysis">
			<span>Geological & Reservoir Analysis</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==2  ? "active":""}>
		<Link to="/SolutionGeophysicalServices">
			<span>Reservoir Stimulation & Activation</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==3  ? "active":""}>
		<Link to="/SolutionDrillingEngineering">
			<span>Well Cleaning & Maintenance</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==4  ? "active":""}>
		<Link to="/SolutionProductionOptimization">
			<span>Real-Time Monitoring & Surveillance</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==5  ? "active":""}>
		<Link to="/SolutionRenewableEnergy">
			<span>Production Optimization (AI & Nanotechnology)</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==6  ? "active":""}>
		<Link to="/SolutionIndustrialMaintenance">
			<span>Drilling & Production Equipment & Chemicals Supply</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==7  ? "active":""}>
		<Link to="/SolutionSupplyChainLogistics">
			<span>Facility Management & Operations Support</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==8  ? "active":""}>
		<Link to="/SolutionEnvironmentalHSE">
			<span>Wells & Facilities Integrity Management</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>

	<li className={this.props.activeService==9  ? "active":""}>
		<Link to="/SolutionTrainingCompetency">
			<span>Mechanical, Electrical & Cryogenic Maintenance</span>
			<i className="fa fa-angle-right"></i>
		</Link>
	</li>
</ul>


					</div>
					{/* <div className="widget">
						<div className="brochure-bx">
							<h5 className="title-head">Download</h5>
							<Link to="#" className="download-link">
								<img src={IconPdf} alt=""/>
								<h5 className="title">Download our Brochures</h5>
								<span>Download</span>
							</Link>
							<Link to="#" className="download-link">
								<img src={IconDoc} alt=""/>
								<h5 className="title">Our Company Details</h5>
								<span>Download</span>
							</Link>
						</div>
					</div> */}
					<div className="widget">
						<div className="help-bx">
							<div className="media">
								<img src={AboutPic3} alt=""/>
							</div>
							<div className="info text-white">
								<img src={HeadPhones} alt=""/>
								<h5 className="title">How Can We Help</h5>
								<p>If you need any helps, please free to contact us.</p>
								<a href="contact" className="btn-secondry">Contact Us</a>
							</div>
						</div>
					</div>
				</aside>
			</>
		);
	}
}

export default SolutionSidebar;
